import React, { Component } from "react";
import ListPelatihan from "./ListPelatihan";

class Pelatihan extends Component {
    render() {
        return (
            <ListPelatihan />
        );
    }
}

export default Pelatihan;